import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './AuthContext'
import {
  isParentUserType,
  useSubscriptionNeedPlan,
} from './commonComponents/SubscriptionNeedPlanContext'
import { hasValidInstituteIdCookie } from '../utils/instituteIdCookie'

const SUBSCRIPTION_ROUTES = ['/admin/subscription', '/admin/subscription/plans']

const isSubscriptionRoute = (pathname) =>
  SUBSCRIPTION_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  )

const SubscriptionPlanGuard = ({ children }) => {
  const { user } = useAuth()
  const location = useLocation()
  const { needPlan, checked } = useSubscriptionNeedPlan()

  if (!user || isParentUserType(user)) {
    return children
  }

  if (hasValidInstituteIdCookie() && !checked) {
    return null
  }

  if (needPlan && !isSubscriptionRoute(location.pathname)) {
    return <Navigate to="/admin/subscription" replace />
  }

  return children
}

export default SubscriptionPlanGuard
